export const registerServiceWorker = async (): Promise<ServiceWorkerRegistration> => {
  const registration = await navigator.serviceWorker.register(
    "/assets/firebase-messaging-sw.js",
    { type: "module" },
  )
  console.log("Service worker registered", registration)
  return registration
}
